<template>
  <div>
    <el-tabs type="card" v-model="tabsCom" >
        <el-tab-pane label="文件白名单" v-if="pageActionNames.includes('file_whitelist_page')" name="ConfigWhiteList"/>
        <el-tab-pane label="文件单独队列" v-if="pageActionNames.includes('file_separate_queue_page')" name="ConfigOnlyList"/>
    </el-tabs>
    <component :pageFunc="pageFunc" :is="tabsCom"/>
  </div>
</template>

<script>
import ConfigWhiteList from "./whiteList.vue"
import ConfigOnlyList from "./onlyList.vue"
export default {
    props: [ 'pageAction', 'pageActionNames'],
    name: 'ConfigListPage',
    components: {
        ConfigWhiteList,
        ConfigOnlyList
    },
    data() {
        const page = this.pageAction.find(v=> {
            return ['file_whitelist_page', 'file_separate_queue_page'].includes(v.name)
        });
        return {
            tabsCom: page.name ==='file_whitelist_page'? 'ConfigWhiteList' :'ConfigOnlyList'
        }
    },
    computed: {
        pageFunc() {
            switch (this.tabsCom) {
                case 'ConfigWhiteList':
                    return this.pageAction.find(v=> v.name ==='file_whitelist_page').func.map(v=>v.name);
                case 'ConfigOnlyList':
                    return this.pageAction.find(v=> v.name ==='file_separate_queue_page').func.map(v=>v.name);
                default:
                    return []
            }
        }
    }
}
</script>

<style lang="scss" scoped>

</style>